import React from "react";
import { Close } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";

const ModalHeaderComponent = (props) => {

    const { close, subtitle } = props;

    return (
      // Explicitly set component="div" to prevent DOM nesting error when used inside DialogTitle
      <Box component="div">
        {/* 1. Primary Title */}
        <Typography
          variant="h6"
          // color="#e2e2e2ff"
          color="#ffffffff"
        >
          Book Appointment
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="subtitle2"
          key={subtitle}
          // color="#e2e2e2ff"
          color="#ffffffff"
          fontWeight={400}
          sx={{
            transition: "opacity 0.3s ease",
          }}
        >
          {subtitle}
        </Typography>

        {/* 2. Close Button */}
        <IconButton
          aria-label="close"
          onClick={close}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#faf9f9ff",
          }}
        >
          <Close />
        </IconButton>
      </Box>
    );
};
export { ModalHeaderComponent };